export default "__VITE_ASSET__cnGRhsM2__"